import { faCheck, faComments, faExchangeAlt, faUserClock } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAuth } from '@polvo-labs/react-auth'
import Axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { RouteProps } from 'react-router-dom'
import { toast } from 'react-toastify'
import Button from '../../../components/Button'
import Chat from '../../../components/Chat'
import { confirm } from '../../../components/Dialog'
import Icon from '../../../components/Icon'
import Loader from '../../../components/Loader'
import Tabs from '../../../components/Tabs'
import Text from '../../../components/Text'
import routes from '../../../config/routes'
import { RoomsContext } from '../../../context/rooms-context'
import UserModal from '../../../modals/Users/index'
import RoomType from '../../../models/Room'
import { StatusChange, useSocket } from '../../../Socket'
import PageContent from '../PageContent'
import PageHeader from '../PageHeader'
import Rooms from './Rooms'
import { ChatContainer, ChatHeader, ChatTitle, Container, Link, TabsContainer } from './styles'

type Props = RouteProps


const ChatScreen: React.FC<Props> = (props) => {

  const socket = useSocket()
  const { token, user } = useAuth()

  const [isLoading, setIsLoading] = useState(false)
  const [isUsersOpen, setIsUsersOpen] = useState(false)
  const { roomsState, roomsDispatch } = useContext(RoomsContext)

  useEffect(() => {
    if (socket && socket.disconnected) {
      socket.connect()
    }
    if (socket) {

      socket.emit('join', {
        room: 'attendant',
      })

      socket.emit('join', {
        room: 'active_room',
      })
    }
    return () => {
      if (socket && socket.connected) {
        socket.removeAllListeners()
        socket.disconnect()
        roomsDispatch({ type: 'reload_all', payload: { roomsRun: [], roomsNotAttended: [], room: undefined } })
      }
    }
  }, [socket])

  const [defaultRoom] = useState<RoomType | undefined>(() => {
    const search = props.location?.search ?? ''
    const match = /\?room=(.*)/.exec(search)
    if (match) {
      const room = JSON.parse(atob(match[1]))
      return room
    }
    return undefined
  })

  const setRoom = (roomParam: any) => {
    roomsDispatch({ type: 'set_room', payload: { room: roomParam } })
  }

  const onSelectTransferChat = (user: any, roomParameter: RoomType | undefined = roomsState.room, close?: () => void) => {
    setIsLoading(true)
    const user_id = user[0]
    if (roomParameter) {
      Axios({
        method: 'PATCH',
        url: `${process.env.REACT_APP_API_URL}/chat/rooms/attendant`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          'room_id': roomParameter.id,
          'user_id': user_id,
        },
      }).then(({ data }) => {
        setIsLoading(false)
        if (close)
          close()
        roomsDispatch({ type: 'transfer_room', uuid: data.data.uuid })
      }).catch(() => {
        setIsLoading(false)
        toast.error('Ocorreu um erro de transação')
      })
    }
  }

  const attendCancelled = (roomParameter: RoomType | undefined = roomsState.room) => {
    confirm({
      title: 'Comfirme',
      message: 'Tem certeza de que deseja enviar em aguardando?',
      buttons: [
        {
          label: 'Sim',
          onClick: () => {
            if (roomParameter !== undefined) {
              setIsLoading(true)
              Axios({
                method: 'DELETE',
                url: `${process.env.REACT_APP_API_URL}/chat/rooms/attendant`,
                headers: {
                  Authorization: `Bearer ${token}`,
                },
                data: {
                  'room_id': roomParameter.id,
                },
              }).then(({ data }) => {
                setIsLoading(false)
                roomsDispatch({ type: 'set_room_attended', payload: undefined, uuid: data.data.uuid })
              }).catch(() => {
                setIsLoading(false)
                toast.error('Ocorreu um erro de transação')
              })
            }
          },
        },
        {
          label: 'Não',
          onClick: () => { },
        },
      ],
    })
  }

  const deactivateRoom = (roomParameter: RoomType | undefined = roomsState.room) => {
    confirm({
      title: 'Comfirme',
      message: 'Tem certeza de que deseja encerrar a conversa?',
      buttons: [
        {
          label: 'Sim',
          onClick: () => {
            if (roomParameter !== undefined) {
              setIsLoading(true)
              Axios({
                method: 'PATCH',
                url: `${process.env.REACT_APP_API_URL}/chat/rooms/${roomParameter.id}/archive`,
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }).then(() => {
                setIsLoading(false)
                toast.info(`Conversa com ${roomParameter.user.name} concluída`)
                const uuid = roomParameter.uuid || ''
                roomsDispatch({ type: 'deactivate_room', uuid: uuid })
              }).catch(() => {
                setIsLoading(false)
                toast.error('Ocorreu um erro de transação')
              })
            }
          },
        },
        {
          label: 'Não',
          onClick: () => { },
        },
      ],
    })
  }

  useEffect(() => {
    let mounted = true
    if (socket) {

      socket.on('attendant', (data: any) => {

        const name = data.user?.name || '- Sem nome'
        Axios({
          method: 'GET',
          url: `${process.env.REACT_APP_API_URL}/users/${data.user?.id}`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).then(({ data }) => {
          if (mounted) {
            const data2 = data.data.chat_room
            data2.last_message = data2.last_message
            data2.receiver_status = data2.user?.chat_status
            data2.now = true
            if (data2.attendant_id) {
              if (data2.attendant_id === user.id) {
                roomsDispatch({ type: 'incoming_transfer_room', room: data2, user_id: user.id })
                toast.info(`O cliente ${name} foi transferido para você`)
              } else {
                toast.info(`O cliente ${name} está sendo atendido por ${data2.attendant.name || ''}`)
                roomsDispatch({ type: 'update_not_attended', room: data2, user_id: user.id })
              }

            } else {
              toast.info(`O cliente ${name} voltou aguardando`)
              roomsDispatch({ type: 'update_not_attended', room: data2, user_id: user.id })
            }
          }
        })
      })

      socket.on('status', (data: StatusChange) => {
        if (mounted) {
          roomsDispatch({ type: 'update_room_status', user_id: data.user, status: data.status })
        }
      })
    }
    return () => {
      mounted = false
    }
  }, [socket, roomsDispatch, user])

  useEffect(() => {
    if (socket) {
      socket.on('active_room', (data: any) => {
        const name = data.user?.name || '- Sem nome'
        if (data.is_active) {
          if (!data.attendant_id) {
            toast.info(`Novo cliente ${name} aguardando`)
            roomsDispatch({ type: 'update_not_attended', room: data, user_id: user.id })
          }
        }

      })
    }

  }, [socket, roomsDispatch, user])

  const attendClick = (roomParameter: RoomType) => {
    if (roomParameter !== undefined) {
      setIsLoading(true)
      Axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_URL}/chat/rooms/attendant`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          'room_id': roomParameter.id,
          'user_id': user.id,
        },
      }).then(() => {
        setIsLoading(false)
      }).catch(() => {
        setIsLoading(false)
        toast.error('Ocorreu um erro ao enviar mensagem')
      })
    }
  }

  const getRoomActions = (roomParameter: RoomType) => {
    return (
      <>
        {((roomParameter.attendant_id || roomParameter.attendant) &&
          <button
            style={{
              marginRight: '10px',
              backgroundColor: 'transparent',
              border: 'none',
              width: '20px',
            }}
            onClick={() => {
              deactivateRoom(roomParameter)
            }}
          >
            <Text
              tag="span"
            >
              <FontAwesomeIcon
                icon={faCheck}
              />
            </Text>
          </button>)
        }
        {
          (roomParameter.attendant_id || roomParameter.attendant) && (
            <button
              style={{
                marginRight: '10px',
                backgroundColor: 'transparent',
                border: 'none',
                width: '20px',
              }}
              onClick={() => {
                setIsUsersOpen(true)
              }}
            >
              <Text
                tag="span"
              >
                <FontAwesomeIcon
                  icon={faExchangeAlt}
                />
              </Text>
            </button>)
        }
        {
          (roomParameter.attendant_id || roomParameter.attendant) && (
            <button
              style={{
                marginRight: '10px',
                backgroundColor: 'transparent',
                border: 'none',
                width: '20px',
              }}
              onClick={() => {
                attendCancelled(roomParameter)
              }}
            >
              <Text
                tag="span"
              >
                <FontAwesomeIcon
                  icon={faUserClock}
                />
              </Text>
            </button>)
        }
        {
          (!roomParameter.attendant_id && !roomParameter.attendant) && (
            <button
              style={{
                marginRight: '10px',
                backgroundColor: 'transparent',
                border: 'none',
                width: '20px',
              }}
              onClick={() => {
                attendClick(roomParameter)
              }}
            >
              <Text
                tag="span"
              >
                {(isLoading ? <Loader
                  darkMode={true}
                  imageStyle={{ height: 'fit-content' }}
                  delay={0}
                /> : <FontAwesomeIcon
                  icon={faComments}
                />)}
              </Text>
            </button>
          )
        }
      </>
    )
  }

  return (
    <div>
      <PageHeader
        title="Chat"
        subtitle=""
      ></PageHeader>
      <PageContent
        style={{ padding: '0px' }}
      >
        {isLoading && (<Loader
          full
        />)}
        <Container
          style={{ minHeight: '350px' }}
        >
          <TabsContainer>
            <Tabs
              style={{ height: '100%', overflow: 'hidden' }}
              header={[`Em andamento (${roomsState.roomsRunTotal})`, `Aguardando (${roomsState.roomsNotAttendedTotal})`]}
              headerStyle={{ minHeight: '47px' }}
              contentStyle={{ borderBottom: 'none', borderLeft: 'none', borderRight: 'none', overflow: 'hidden', height: 'calc(100% - 47px)' }}
              activeTab={roomsState.currentTab}
            >
              <Rooms
                roomActions={getRoomActions}
                room={roomsState.room}
                defaultRoom={defaultRoom}
                isAttendance={true}
                rooms={roomsState.roomsRun}
              />
              <Rooms
                roomActions={getRoomActions}
                room={undefined}
                defaultRoom={undefined}
                rooms={roomsState.roomsNotAttended}
              />
            </Tabs>
          </TabsContainer>
          {roomsState.room && (
            <ChatContainer>
              <ChatHeader>
                <Button
                  label={(
                    <Icon
                      name="close"
                    />
                  )}
                  backgroundColor="transparent"
                  onClick={() => {
                    setTimeout(() => {
                      setRoom(undefined)
                    }, 0)
                  }}
                />
                <Link
                  style={{ margin: 'auto' }}
                  to={routes.admin.user.show.pathFor(roomsState.room.user.id)}
                >
                  <ChatTitle
                    className="chat-title"
                    tag="h2"
                    style={{
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      maxWidth: '350px',
                      whiteSpace: 'nowrap',
                      display: 'block',
                      margin: 0,
                    }}
                  >
                    {roomsState.room.user.name}
                  </ChatTitle>
                </Link>
                {getRoomActions(roomsState.room)}
              </ChatHeader>
              <Chat
                room={roomsState.room}
                visualizing={true}
                setRoom={setRoom}
              />
            </ChatContainer>
          )}

        </Container>
        <UserModal
          onSelect={onSelectTransferChat}
          isOpenExternal={isUsersOpen}
          setIsOpenExternal={setIsUsersOpen}
        />
      </PageContent>
    </div>
  )
}

export default ChatScreen
